import { UserHeader, UserInfo } from '@features/modals/UserInfoModal/components';
import { Uuid } from '@/api/types';
import { useComposedEmployeeByIdQuery } from '@/queries/employee';
import { UserModalSkeleton } from './UserModalSkeleton';

export const EmployeeModalContent = ({ employeeId }: { employeeId: Uuid }) => {
  const { data } = useComposedEmployeeByIdQuery(employeeId);

  if (!data) return <UserModalSkeleton />;

  return (
    <>
      <UserHeader user={data} />
      <UserInfo user={data} />
    </>
  );
};
